export const hasUppercaseChar = (value: string) => /[A-Z]/.test(value)
export const hasLowercaseChar = (value: string) => /[a-z]/.test(value)
export const hasANumber = (value: string) => /\d/.test(value)
export const hasSymbol = (value: string) => /[?!/]/.test(value)
export const notEmptyArray = (value: unknown) => Array.isArray(value) && value.length > 0
export const hasUniqueValues = (value: unknown) => Array.isArray(value) && new Set(value).size === value.length
